import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormControlDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Constants } from 'src/app/shared/model/Constants';
import { ControlSettings } from '../../ControlSettings';

@Component({
  selector: 'numeric-input-ctrl',
  templateUrl: './numeric-input.component.html',
  styleUrls: ['./numeric-input.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: NumericInputComponent,
    multi: true
  }]
})
export class NumericInputComponent  implements ControlValueAccessor {

  constructor(private controlContainer: ControlContainer) {
  }

   @ViewChild(FormControlDirective, {static: true})
   
   formControlDirective: FormControlDirective;
   
   @Input() formControlName: string;
   @Input() caption: string;

   @Input() settings:ControlSettings = {};
   defaultSettings:ControlSettings = {format:'n',step:1, fxFill:false, min:0,max:Constants.MaxInt, readonly:false};

   @Output() valueChangeEvent = new EventEmitter<any>();
   @Output() blurEvent = new EventEmitter();
  
   ngOnInit(): void {
   Object.assign(this.defaultSettings,this.settings);
    this.settings = this.defaultSettings;
  }

  ngAfterViewInit() {
    const selector = '#' + this.formControlName + ' .k-input';
    const input = document.querySelector(selector) as HTMLElement;
    if(input){
      input.setAttribute("inputmode", "numeric");
    }
  }


  get control() {
    return  this.controlContainer.control.get(this.formControlName);
  }

  onChange(value:string){
    this.control.setValue(value);
    this.valueChangeEvent.emit(value);
  }

  onBlur(){
    this.blurEvent.emit(this.control.value);
  }

  
  //implement ControlValueAccessor
  registerOnTouched(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnTouched(fn);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnChange(fn);
  }

  writeValue(obj: any): void {
    this.formControlDirective.valueAccessor.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDirective.valueAccessor.setDisabledState(isDisabled);
  }


}
